import type { Permission } from '../hooks/useRoles';
import { TENANT_CAPABILITIES } from './permissions-vocab';
import './TenantCapabilityList.css';

interface Props {
  permissions: Permission[];
  disabled: boolean;
  /** Called with (capability, wasChecked). Parent posts/deletes accordingly. */
  onToggle: (capability: string, wasChecked: boolean) => void;
}

export function TenantCapabilityList({ permissions, disabled, onToggle }: Props) {
  const granted = new Set(
    permissions.filter((p) => p.stage === '*').map((p) => p.action),
  );

  return (
    <div className="tcl-section">
      <div className="rb-section-title">Tenant Capabilities</div>
      {/* R-162 §10.1 — capability changes are baked into the operator's Redis
          session at the auth callback, so they don't apply until they sign in
          again. */}
      <p className="tcl-hint">Takes effect on the operator&apos;s next login.</p>
      <div className="tcl-grid">
        {TENANT_CAPABILITIES.map((cap) => {
          const checked = granted.has(cap.id);
          return (
            <label key={cap.id} className="tcl-row">
              <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={() => onToggle(cap.id, checked)}
                aria-label={cap.label}
              />
              <span>{cap.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
